import React, { useEffect, useState } from "react";
import TextField from '@material-ui/core/TextField'
import Checkbox from '@material-ui/core/Checkbox'
import FormControlLabel from '@material-ui/core/FormControlLabel'

import SvgIcon from "@material-ui/core/SvgIcon"
import { ReactComponent as CheckedIcon } from '../../assets/default/images/checked-icon.svg'
import { ReactComponent as UncheckedIcon } from '../../assets/default/images/unchecked-icon.svg'

interface MessageProps {
  [key: string]: any
}

const Message: React.FC<MessageProps> = (props: any) => {

  const [ showMessageContent, setShowMessageContent ] = useState(props.values.message_to_charity.length > 0 ? true : false)
  const [ charsLeft, setCharsLeft ] = useState(250)

  function countCharsLeft(e:any) {
    setCharsLeft(250 - e.length);
  }

  useEffect(() => {
    if (props.values.message_to_charity.length > 0) {
      setShowMessageContent(true);
    }
  }, [props.values.message_to_charity.length])

  return (
    <>
      <div className="row">
        <div className="your-message clearfix box">
          <div className="medium-12 columns">
            <div className="input-container">
              <FormControlLabel
                control={
                  <Checkbox
                    name="show_message_checkbox"
                    id="show-message-checkbox"
                    icon={<SvgIcon><UncheckedIcon /></SvgIcon>}
                    checkedIcon={<SvgIcon><CheckedIcon /></SvgIcon>}
                    color="primary"
                    checked={showMessageContent}
                    onClick={() => {
                      setShowMessageContent(!showMessageContent)
                      if (showMessageContent) {
                        props.setFieldValue('message_to_charity', '')
                      }
                    }}
                  />
                }
                label="I'd like to leave a message with my donation"
                labelPlacement="end"
              />
            </div>
            { showMessageContent &&
              <div className="input-container">
                <TextField
                  type="text"
                  variant="outlined"
                  id="message-to-charity"
                  name="message_to_charity"
                  label="Please leave your message here"
                  multiline
                  rowsMax={4}
                  inputProps={{ maxLength: 250 }}
                  value={props.values.message_to_charity}
                  onChange={(e) => {
                    props.handleChange(e)
                    countCharsLeft(e.target.value)
                  }} />
                <div className="maxlength">{charsLeft} characters left</div>
              </div>
            }
          </div>
        </div>
      </div>
    </>
  );
};

export default Message;